module.exports = __webpack_public_path__ + "static/media/soundify.64d97316.png";